// Mock data pour Gratia Animalis

export const businessInfo = {
  name: "Gratia Animalis",
  tagline: "Massage et Bien-être pour Chevaux et Chiens",
  phone: "+330778760491",
  email: "gratia.animalis@gmail.com",
  facebook: "https://www.facebook.com/share/15uFkxF5Xj/?mibextid=wwXIfr",
  instagram: "https://www.instagram.com/gratia_animalis?igsh=MXFrZml3ZHBlOXR0YQ%3D%3D&utm_source=qr",
  location: "Saint-Médard-en-Jalles, Nouvelle-Aquitaine",
  coverageArea: "Nouvelle-Aquitaine"
};

export const certifications = [
  {
    name: "Equiphysio",
    description: "Formation certifiée en massage équin : 412,5 heures en organisme avec cours d'anatomie, zootechnie et physiologie. Plus de 500 heures de stage pratique. Plus de 250 heures de recherche pour étude de cas et soutenance. Soit plus de 1100 heures de formation.",
    logo: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/iz2mir5z_E8D3553E-1A2E-42DF-8D9E-53C5F436E3C7.jpeg"
  },
  {
    name: "Kelpy",
    description: "Formation en enveloppement aux algues et boue marine"
  }
];

export const servicesEquin = [
  {
    id: 1,
    title: "Première prise en charge",
    price: "100€",
    description: "Évaluation complète et première séance de massage personnalisée",
    duration: "90 min"
  },
  {
    id: 2,
    title: "Massage d'entretien",
    price: "80€",
    description: "Séance régulière pour maintenir le bien-être de votre cheval",
    duration: "60 min"
  },
  {
    id: 3,
    title: "Massage préparation à l'effort",
    price: "40€",
    description: "Préparation musculaire avant compétition, entraînement intensif, gros transport ou effort important",
    duration: "20 min"
  },
  {
    id: 4,
    title: "Massage récupération à l'effort",
    price: "50€",
    description: "Récupération musculaire après effort intense",
    duration: "30 min"
  },
  {
    id: 5,
    title: "Préparation + Récupération",
    price: "80€",
    description: "Formule complète avant et après l'effort",
    duration: "50 min"
  },
  {
    id: 6,
    title: "Enveloppement aux algues",
    price: "+30€",
    description: "Soin complémentaire aux propriétés relaxantes et reminéralisantes"
  }
];

export const forfaitsEquin = [
  {
    name: "Harmonie",
    price: "430€",
    sessions: "6 massages d'entretien",
    savings: "Économisez 50€",
    description: "Idéal pour un suivi régulier du bien-être de votre cheval"
  },
  {
    name: "Équilibre",
    price: "820€",
    sessions: "12 massages d'entretien",
    savings: "Économisez 140€",
    description: "Le meilleur rapport qualité-prix pour un accompagnement annuel",
    popular: true
  },
  {
    name: "Sport Essentiel",
    price: "320€",
    sessions: "2 massages entretien + 2 préparation + 2 récupération",
    savings: "Économisez 40€",
    description: "Pour les chevaux en activité sportive modérée"
  },
  {
    name: "Sport Performance",
    price: "460€",
    sessions: "3 massages entretien + 3 préparation + 3 récupération",
    savings: "Économisez 80€",
    description: "Pour les athlètes équins en compétition régulière"
  },
  {
    name: "Athlète",
    price: "580€",
    sessions: "4 massages entretien + 4 préparation + 4 récupération",
    savings: "Économisez 140€",
    description: "L'excellence pour les chevaux de haut niveau"
  }
];

export const servicesCanin = [
  {
    id: 1,
    title: "Première prise en charge",
    price: "50€",
    description: "Évaluation complète et première séance de massage personnalisée",
    duration: "1h"
  },
  {
    id: 2,
    title: "Massage d'entretien",
    price: "40€",
    description: "Séance régulière pour maintenir le bien-être de votre chien",
    duration: "Environ 45 min"
  },
  {
    id: 3,
    title: "Massage préparation à l'effort",
    price: "20€",
    description: "Préparation musculaire avant compétition, activité intense, gros transport ou effort important",
    duration: "10 min"
  },
  {
    id: 4,
    title: "Massage récupération à l'effort",
    price: "30€",
    description: "Récupération musculaire après effort",
    duration: "20 min"
  },
  {
    id: 5,
    title: "Préparation + Récupération",
    price: "40€",
    description: "Formule complète avant et après l'effort",
    duration: "30 min"
  },
  {
    id: 6,
    title: "Enveloppement aux algues",
    price: "+10€",
    description: "Soin complémentaire aux propriétés relaxantes"
  }
];

export const forfaitsCanin = [
  {
    name: "Harmonie",
    price: "215€",
    sessions: "6 massages d'entretien",
    savings: "Économisez 25€",
    description: "Idéal pour un suivi régulier du bien-être de votre chien"
  },
  {
    name: "Équilibre",
    price: "405€",
    sessions: "12 massages d'entretien",
    savings: "Économisez 75€",
    description: "Le meilleur rapport qualité-prix pour un accompagnement annuel",
    popular: true
  },
  {
    name: "Sport Essentiel",
    price: "170€",
    sessions: "2 massages entretien + 2 préparation + 2 récupération",
    savings: "Économisez 30€",
    description: "Pour les chiens en activité sportive modérée"
  },
  {
    name: "Sport Performance",
    price: "240€",
    sessions: "3 massages entretien + 3 préparation + 3 récupération",
    savings: "Économisez 60€",
    description: "Pour les athlètes canins en compétition régulière"
  },
  {
    name: "Athlète",
    price: "300€",
    sessions: "4 massages entretien + 4 préparation + 4 récupération",
    savings: "Économisez 100€",
    description: "L'excellence pour les chiens de haut niveau"
  }
];

export const travelFees = [
  { distance: "0-20 km", fee: "Sans surplus", from: "Saint-Médard-en-Jalles" },
  { distance: "20-40 km", fee: "+10€", from: "Saint-Médard-en-Jalles" },
  { distance: "40-60 km", fee: "+20€", from: "Saint-Médard-en-Jalles" },
  { distance: "60-80 km", fee: "+30€", from: "Saint-Médard-en-Jalles" },
  { distance: "80-100 km", fee: "+40€", from: "Saint-Médard-en-Jalles" },
  { distance: "Au-delà de 100 km", fee: "Sur devis", from: "Saint-Médard-en-Jalles" }
];

export const galleryImages = [
  {
    url: "https://customer-assets.emergentagent.com/job_e2a2556f-740b-44c6-9c8b-7e07e2009543/artifacts/4g06v4j7_IMG_1693.jpeg",
    category: "both",
    alt: "Massage équin et canin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/wfj5ff2r_IMG_1648.jpeg",
    category: "canin",
    alt: "Massage canin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/42h7wti3_IMG_1681.jpeg",
    category: "canin",
    alt: "Soin canin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/e6kij4ug_IMG_1683.jpeg",
    category: "canin",
    alt: "Massage chien"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/noqwm0a9_IMG_1600.jpeg",
    category: "canin",
    alt: "Massage canin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/rs74o76j_IMG_1610.jpeg",
    category: "canin",
    alt: "Soin canin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/bclww4yq_IMG_1611.jpeg",
    category: "canin",
    alt: "Massage canin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/f7gpyrm4_IMG_1640.jpeg",
    category: "canin",
    alt: "Soin canin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/3x0cfr4z_IMG_1664.jpeg",
    category: "canin",
    alt: "Massage chien"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/93aa4jba_IMG_1563.jpeg",
    category: "canin",
    alt: "Soin canin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/40avtvuz_IMG_1558.jpeg",
    category: "canin",
    alt: "Massage canin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/rfu1nzf7_IMG_1564.jpeg",
    category: "canin",
    alt: "Soin canin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/ld9wwaif_IMG_1575.jpeg",
    category: "canin",
    alt: "Massage chien"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/gcbnew1l_IMG_1580.jpeg",
    category: "canin",
    alt: "Massage canin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/4jj09j0g_IMG_1556.jpeg",
    category: "canin",
    alt: "Massage canin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/0c2n5bp2_IMG_1557.jpeg",
    category: "canin",
    alt: "Soin canin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/b5rdmnv3_IMG_1532.jpeg",
    category: "equin",
    alt: "Enveloppement algues cheval"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/4jajsgmr_IMG_1309.jpeg",
    category: "equin",
    alt: "Cheval"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/a4gits6d_IMG_0492.jpeg",
    category: "equin",
    alt: "Massage équin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/ovdsonin_IMG_0493.jpeg",
    category: "equin",
    alt: "Soin équin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/z1ihenw0_IMG_0501.jpeg",
    category: "equin",
    alt: "Massage équin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/withhsme_IMG_0503.jpeg",
    category: "equin",
    alt: "Technique massage"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/2xqp4bby_IMG_0504.jpeg",
    category: "equin",
    alt: "Massage équin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/kr9k438u_IMG_0462.jpeg",
    category: "equin",
    alt: "Soin équin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/zi1vyasf_IMG_0469.jpeg",
    category: "equin",
    alt: "Massage équin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/jjlmpnnx_IMG_0465.jpeg",
    category: "equin",
    alt: "Technique massage"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/kuo35sz0_IMG_0482.jpeg",
    category: "equin",
    alt: "Massage équin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/5vk2quba_IMG_0485.jpeg",
    category: "equin",
    alt: "Soin équin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/ggozo12y_IMG_0407.jpeg",
    category: "equin",
    alt: "Massage équin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/1v4st0lu_IMG_0397.jpeg",
    category: "equin",
    alt: "Soin équin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/uw5k5tf3_IMG_0408.jpeg",
    category: "equin",
    alt: "Massage équin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/07e5bjn2_IMG_0393.jpeg",
    category: "equin",
    alt: "Soin cheval"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/fijl6agl_IMG_0388.jpeg",
    category: "equin",
    alt: "Massage équin"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/liw8znfx_IMG_0297.jpeg",
    category: "equin",
    alt: "Cheval"
  }
];

export const faqData = [
  {
    question: "Pourquoi faire masser mon cheval ou mon chien ?",
    answer: "Le massage animalier améliore la circulation sanguine, réduit les tensions musculaires, favorise la récupération après l'effort et contribue au bien-être général de votre animal. Il peut également aider à prévenir les blessures et à détecter les zones de tension."
  },
  {
    question: "À quelle fréquence dois-je faire masser mon animal ?",
    answer: "Pour un massage d'entretien, une séance mensuelle est recommandée. Pour les animaux sportifs, un massage avant et après les compétitions est idéal. La fréquence peut être adaptée selon les besoins spécifiques de votre animal."
  },
  {
    question: "Mon animal doit-il avoir un problème spécifique pour bénéficier d'un massage ?",
    answer: "Non, le massage est bénéfique pour tous les animaux en bonne santé. Il contribue au bien-être général, à la détente et peut prévenir l'apparition de tensions musculaires. Note importante : je n'accepte pas les animaux malades nécessitant des soins vétérinaires, à l'exception des maladies chroniques pour lesquelles une prise en charge peut être envisagée après validation."
  },
  {
    question: "Combien de temps dure une séance ?",
    answer: "La durée varie selon le type de prestation : de 10 minutes pour une préparation canine à 90 minutes pour une première prise en charge équine complète. Les massages d'entretien durent généralement 60 minutes pour les chevaux et environ 45 minutes pour les chiens."
  },
  {
    question: "Qu'est-ce que l'enveloppement aux algues ?",
    answer: "L'enveloppement aux algues est un soin complémentaire utilisant les propriétés naturelles des algues marines. Il favorise la détente, la reminéralisation et peut aider à soulager les tensions musculaires. C'est un excellent complément au massage."
  },
  {
    question: "Puis-je assister à la séance de massage ?",
    answer: "Oui, votre présence est indispensable lors de toutes les prises en charge. Cela rassure votre animal et vous permet de voir les techniques utilisées et les zones travaillées."
  },
  {
    question: "Quelles sont vos qualifications ?",
    answer: "Je suis certifiée Equiphysio pour le massage équin et j'ai suivi la formation Kelpy pour les enveloppements aux algues et boue marine. Ces formations reconnues garantissent des soins professionnels et adaptés aux besoins de vos animaux."
  },
  {
    question: "Comment prendre rendez-vous ?",
    answer: "Vous pouvez prendre rendez-vous directement via le formulaire en ligne sur ce site, par téléphone au +33 07 78 76 04 91, ou par SMS. Je vous recontacterai pour confirmer la date et l'heure."
  }
];

export const testimonials = [
  {
    name: "Adeline & Suggie",
    location: "Nouvelle-Aquitaine",
    text: "Elisa a suivi ma jument Suggie sur sa saison de concours. Dès la première fois j'ai trouvé une jument beaucoup plus disponible, concentrée, dès le début de l'échauffement. Concernant la récupération, Suggie vit au pré, et la mise au box lors des concours après des efforts intenses provoquent de légers engorgements. Avec les massages ses engorgements sont fortement diminués. Elisa est très professionnelle tant dans ses prises en charge que dans ses retours. Un grand merci !",
    rating: 5,
    animal: "Cheval"
  },
  {
    name: "Philippe & Spat",
    location: "Nouvelle-Aquitaine",
    text: "J'ai confié mon étalon Spat à Élisa lors de nos compétitions. Le temps de détente a été réduit de manière significative. Spat était concentré, souple et particulièrement mobile en très peu de temps. Nos concours se jouant sur le week-end, la séance de récupération du samedi soir me semble essentielle. Le dimanche Spat n'était ni fatigué, ni courbaturé. Une sacrée expérience pour optimiser le physique de nos athlètes. Merci à elle !!!",
    rating: 5,
    animal: "Cheval"
  },
  {
    name: "Gwen & DCM",
    location: "Nouvelle-Aquitaine",
    text: "Pour notre seconde saison de compétition, la présence d'Elisa a été plus qu'appréciée ! Entre les massages d'entretien réguliers, des séances de travail adaptées et les mobilisations et massages de récupération en compétition, DCM a une meilleure disponibilité, mais aussi un mieux-être global dans son corps. Elle est un atout pour l'entretien de nos sportifs, qu'importe le niveau. Merci encore de nous deux !",
    rating: 5,
    animal: "Cheval"
  },
  {
    name: "Anne-Marie & Fidalgo",
    location: "Nouvelle-Aquitaine",
    text: "Elisa a fait un massage de préparation à l'effort lors d'une compétition de ranch sorting. Fidalgo a un tempérament froid et a besoin d'une détente énergique pour qu'il soit en avant et réactif. Lors de cette détente juste après le massage, je l'ai trouvé beaucoup plus rapidement délié et moins raide qu'au début de nos séances habituelles. Je trouve que c'est un vrai plus pour le cheval d'avoir ce type de massage avant chaque effort. Je remercie Elisa pour son professionnalisme et son écoute du cheval et de son humain.",
    rating: 5,
    animal: "Cheval"
  },
  {
    name: "Hélène & June",
    location: "Nouvelle-Aquitaine",
    text: "Après la séance, elle a dormi au moins 1h. Puis, après, je suis allée la balader et elle n'était pas particulièrement raide. Au contraire, elle était de super bonne humeur, joueuse, elle courait et me proposait de jouer avec elle. Les jours qui ont suivi, elle était plus souple quand elle jouait, comme si elle avait un peu plus de mobilité. En tout cas, aucun effet négatif n'a été visible après la séance, au contraire. Merci pour elle !",
    rating: 5,
    animal: "Chien"
  }
];

export const whyMassage = [
  {
    title: "Amélioration de la performance",
    description: "Le massage prépare les muscles à l'effort et optimise les capacités physiques de votre animal sportif.",
    icon: "trophy"
  },
  {
    title: "Récupération optimale",
    description: "Accélère la récupération musculaire après l'effort et réduit les courbatures et la fatigue.",
    icon: "heart"
  },
  {
    title: "Prévention des blessures",
    description: "Détecte les zones de tension et prévient les blessures musculaires en maintenant une bonne souplesse.",
    icon: "shield"
  },
  {
    title: "Bien-être et détente",
    description: "Favorise la relaxation, réduit le stress et améliore le bien-être général de votre animal.",
    icon: "sparkles"
  },
  {
    title: "Circulation sanguine",
    description: "Améliore la circulation sanguine et lymphatique, favorisant l'élimination des toxines.",
    icon: "activity"
  },
  {
    title: "Lien avec votre animal",
    description: "Renforce la relation de confiance et de complicité entre vous et votre compagnon.",
    icon: "heart"
  }
];